export const careerUrls = {
  home: () => '/career/',
  vacancies: () => '/vacancies/',
  vacancy: (id: number) => `/vacancies/${id}/`,
  team: (slug: string) => `/team/${encodeURIComponent(slug)}/`,
  person: (slug: string) => `/person/${encodeURIComponent(slug)}/`,
};
